import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatAllowedExtensions } from 'utils/fileName';

/**
 * Renders tooltip content showing allowed media file types and recommended dimensions for uploads
 * @param {string[]} extensions - Array of allowed file extensions (e.g., ['jpg', 'png', 'pdf'])
 * @param {object} config - Media configuration object containing dimension constraints
 * @param {boolean} displayMaxSizeMessage - Whether to display recommended dimensions in the tooltip
 * @returns {string|React.ReactElement} Tooltip content with file types and optional dimensions
 */
export const renderAllowedMediaTooltip = (extensions, config, displayMaxSizeMessage) => {
  if (extensions.length === 0) {
    return '';
  }

  const allowedFileTypeLabel = formatAllowedExtensions(extensions);

  if (!config) {
    return allowedFileTypeLabel;
  }

  const mediaConfig = config?.[Object.keys(config)[0]];

  if (!mediaConfig) {
    return allowedFileTypeLabel;
  }

  const width = mediaConfig['max-width'];
  const height = mediaConfig['max-height'];

  return (
    <div>
      <div>{allowedFileTypeLabel}</div>
      {displayMaxSizeMessage && width && height && (
        <div className="mt-2 border-top pt-2">
          <div className="text-center">
            <FormattedMessage id="recommendedFormat" defaultMessage="Recommended format" />
          </div>
          <ul className="pl-3 pt-1">
            <li className="list-disc">{`${width}x${height}`}</li>
          </ul>
        </div>
      )}
    </div>
  );
};
